<template>
  <section class="mt-8 flex flex-col gap-16 p-24 pb-8">
    <RevLink
      v-for="link in links.filter(({ name }) => name !== 'buyback')"
      :key="link.name"
      class="body-2-bold flex items-center gap-4"
      :target="link.external ? '_blanks' : '_self'"
      :to="link.href"
      :tracking="{ zone: 'nav', name: link.name }"
      :underlined="false"
      @click="toggle"
    >
      <span :class="link.classNames">
        {{ link.label }}
      </span>

      <component
        :is="link.icon"
        v-if="link.icon"
        :class="[link.classNames, 'h-16 w-16']"
      />
    </RevLink>
  </section>
</template>

<script setup lang="ts">
import { RevLink } from '@ds/components/Link'

import { useNavLinks } from '../../composables/useNavLinks'
import { useNavigation } from '../../composables/useNavigation'

const { links } = useNavLinks()
const { toggle } = useNavigation()
</script>
